import { Navigate, Outlet, useLocation } from 'react-router'

import { isLanguageValid, getDefaultLanguage } from '@libs/i18n/i18n'

import type { JSX } from 'react'

// Racine du router : redirige vers la langue par défaut quand le segment `:language` de l'URL n'est pas une
// langue supportée, sinon laisse passer l'arbre de routes (`<Outlet />`). Extrait de `router.routes.tsx` pour que
// ce dernier n'exporte qu'une constante (`routes`) — react-refresh (`only-export-components`) interdit un fichier
// qui mélange déclaration de composant et export de données, même quand le composant lui-même n'est pas exporté.
export const RootElement = (): JSX.Element => {
  const location = useLocation()

  const getLanguageFromPath = (): string | undefined => {
    const language = location.pathname.split('/')[1]
    return language
  }

  const getDefaultPath = (): string => {
    const slice = location.pathname.split('/').slice(2)
    const defaultPath = `/${getDefaultLanguage()}/${slice.join('/')}`

    return defaultPath
  }

  return isLanguageValid(getLanguageFromPath()) ? <Outlet /> : <Navigate to={getDefaultPath()} />
}
